var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7cdc63ab375226e40d7a0ccfbb6b227a10e066b2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@incept-3d"]={id:"7cdc63ab375226e40d7a0ccfbb6b227a10e066b2"};
      